import React from 'react';
import { useTranslation } from 'react-i18next';
import U2000ActionBtn from '../../../u2000Core/components/buttons/U2000ActionBtn';
import U2000ResponsiveToolbar from '../../../u2000Core/components/toolbar/U2000ResponsiveToolbar';
import { FaPlus, FaRegFile, FaTrashAlt } from 'react-icons/fa';
import { useU2000AuthContext } from '../../../u2000Core/context/auth/U2000UseAuthContext';
import type { U2000FormStateHandlers } from '../../../u2000Core/reducer/formReducer/U2000FormStateHandlers';
import { U2000FormStateEnumState } from '../../../u2000Core/reducer/formReducer/U2000FormState';
import { NS, U3206ROLES } from '../../U3206';
import type { U3206AiUserGroupFormRow } from '../../U3206Service';

interface U3206AiUserGroupFormToolBarProps {
  formStateHandlers: U2000FormStateHandlers<U3206AiUserGroupFormRow> & {
    getData: () => U3206AiUserGroupFormRow | null;
    getFormState: () => U2000FormStateEnumState;
    addNewGroup: () => void;
    modifyGroup: () => void;
    deleteGroup: () => void;
  };
}

export const U3206AiUserGroupFormToolBar: React.FC<U3206AiUserGroupFormToolBarProps> = ({ formStateHandlers }) => {
  const formState = formStateHandlers.getFormState();
  const { hasRole } = useU2000AuthContext();
  const { t } = useTranslation();

  const actions = [
    {
      key: 'add',
      label: t('btnAdd', { ns: NS }),
      hasRole: hasRole(U3206ROLES.ADD),
      handleClick: () => formStateHandlers.addNewGroup(),
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaPlus,
      Component: U2000ActionBtn,
    },
    {
      key: 'modify',
      label: t('btnModify', { ns: NS }),
      hasRole: hasRole(U3206ROLES.EDIT),
      handleClick: () => formStateHandlers.modifyGroup(),
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaRegFile,
      Component: U2000ActionBtn,
    },
    {
      key: 'delete',
      label: t('btnDelete', { ns: NS }),
      hasRole: hasRole(U3206ROLES.DELETE),
      handleClick: () => formStateHandlers.deleteGroup(),
      disabled: formState === U2000FormStateEnumState.EDIT,
      icon: FaTrashAlt,
      Component: U2000ActionBtn,
    },
  ];

  return <U2000ResponsiveToolbar actions={actions} />;
};
